    function toggle_visibility(id) {
       var e = document.getElementById(id);
       if(e.style.display == 'block')
          e.style.display = 'none';
       else
          e.style.display = 'block';
	}
	
    function hide_visibility(id) {
        var e = document.getElementById(id);
        e.style.display = 'none';
    }  
    
    function show_visibility(id) {
        var e = document.getElementById(id);
        e.style.display = 'block';
    } 
    
    function toggle_visibility_jquery(id) {
        void 0;
        jQuery( 'div#'+id).toggle( "slow");
    } 
    
    function animate_visibility_jquery(id) {
        var div = jQuery('div#'+id);
        //console.log(div.css('display'));
        if(typeof window.orientation !== 'undefined'){
            if(div.css('display') === 'none'){
                div.css({'opacity': 1});
                div.css({'height' : 'auto'});
                div.css({'display' : 'block'});
            } else {
                div.css({'opacity': 0});
                div.css({'height': '0px'});
                div.css({'display' : 'none'});
            }
        } else {
            //div.animate({height: 'toggle', opacity: 'toggle'}, 'slow');
            div.slideToggle();
        }
        thumb_appearance(id);
    }
        
        
document.addEventListener('touchstart', handleTouchStart, false);        
document.addEventListener('touchmove', handleTouchMove, false);

var xDown = null;                                                        
var yDown = null;       

function handleTouchStart(evt) {                                         
    xDown = evt.touches[0].clientX;                                      
    yDown = evt.touches[0].clientY;                                      
}

function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
        return;
    }
    var twistWrapper = document.getElementById( 'twist' ),
        container = twistWrapper.querySelector( '.container' ),
        contentWrapper = container.querySelector( '.wrapper' );

    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
        if ( xDiff > 0 ) {
            /* left swipe */
            //console.log('left');      
            if( classie.has( twistWrapper, 'animate') ) {
                var onEndTransFn = function( ev ) {
                    if( support && ( ev.target.className !== 'container' || ev.propertyName.indexOf( 'transform' ) == -1 ) ) return;
                    this.removeEventListener( transEndEventName, onEndTransFn );
                    classie.remove( twistWrapper, 'open' );
                    document.body.scrollTop = document.documentElement.scrollTop = docscroll;
                    contentWrapper.style.top = '0px';
                    if(document.getElementById('wpadminbar')){
                        document.getElementById('showMenu').style.top = '34px';
                    }
                };
                twistWrapper.addEventListener( transEndEventName, onEndTransFn );
                classie.remove( twistWrapper, 'animate' );
                document.getElementById('hide_link').style.display = 'none';
            }          
        } else {
            /* right swipe */
            //console.log('right');
            evt.stopPropagation();
            evt.preventDefault();
            docscroll = scrollY();
            // change top of contentWrapper
            contentWrapper.style.top = docscroll * -1 + 'px';
            // mac chrome issue:
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            // add modalview class
            classie.add( twistWrapper, 'open' );
            //Hide_link div : activée
            document.getElementById('hide_link').style.display = 'block';
            document.getElementById('showMenu').style.top = '2px';
            // animate..
            setTimeout( function() { classie.add( twistWrapper, 'animate' ); }, 25 );   
        }                       
    } else {
        if ( yDiff > 0 ) {
            /* up swipe */ 
            //console.log('up');
        } else { 
            /* down swipe */
            //console.log('down');
        }                                                                 
    }
    /* reset values */
    xDown = null;
    yDown = null;                                             
}

//function fix_scroll() {
//  var s = $(window).scrollTop();
//  var fixedTitle = $('#loader-wrapper');
//  fixedTitle.css('position','absolute');
//  fixedTitle.css('top',s + 'px');
//}fix_scroll();
//
//$(window).on('scroll',fix_scroll);

function rgb2hex(rgb){
 rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
 return (rgb && rgb.length === 4) ? "#" +
  ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
  ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
  ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
}

jQuery( document ).ready(function() {
    var theColorIs = jQuery('a').css('color');
    void 0;
    //theColorIs = theColorIs.toString();

    jQuery('head').append('<meta name="theme-color" content="'+theColorIs+'"/>');
    jQuery('head').append('<meta name="msapplication-navbutton-color" content="'+theColorIs+'"/>');
    jQuery('head').append('<meta name="apple-mobile-web-app-status-bar-style" content="'+theColorIs+'"/>');
    //document.getElementsByTagName('head')[0].appendChild('<meta name="theme-color" content=theColorIs/>');
});

function add_search_to_firefox(){
    engineURL = '/search_firefox.xml';
    void 0;
    window.external.AddSearchProvider(engineURL);
}

/**
 * Glissement des thumbnails au chargement de la page
 * @param {string} div
 * @returns {none}
 */
function thumb_appearance (div){
    var div_to_process = document.getElementById(div);
    var thumb_classes = [].slice.apply(div_to_process.getElementsByClassName('thumbnail_post'));

    for (var i = 0; i < thumb_classes.length; i++) {
        if(jQuery(thumb_classes[i]).hasClass('active')){
            prec_name = thumb_classes[i].className.replace(' active', '');
            thumb_classes[i].className = prec_name;
        } else {
            thumb_classes[i].className += ' active';
        }
    }
}

function upperFirstChar (string){
    string = string.toLowerCase();
    var charUnion = string.indexOf("-");
    var uperFirst = string.charAt(0).toUpperCase();
    if (charUnion === -1){
        string = uperFirst+string.substr(1);
    } else {
        var uperUnion = string.substr(charUnion+1).charAt(0).toUpperCase();
        string = uperFirst+string.substr(1, charUnion)+uperUnion+string.substr(charUnion+2);
    }
    return string;
}

(function removeLoader(){
    document.addEventListener('DOMContentLoaded', function(){
        if(document.getElementById('page-loader')){
            document.getElementById('page-loader').style.display = 'none';
            document.getElementById('main-loader').style.display = 'none';
        }
    });
})();